module.exports = __webpack_public_path__ + "static/media/blog-personalization-pick-a-color.3303224a.jpg";